<template>
    <transition name="fade">
        <div v-if="show" class="cookie-info p-3">
            <b-row align-v="center">
                <b-col class="text-right">
                    We are using cookies in order to optimize your experience with our website.<br/>
                    For more information on the topic please visit our
                    <router-link class="inline" :to="{ path: '/page/privacy' }">Data Privacy</router-link>
                    information page.
                </b-col>
                <b-col class="text-left">
                    <b-button class="border border-white" variant="primary" @click="close()">OK, I
                        understand
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </transition>
</template>
<script>


    export default {
        name: "cookie-info",
        data() {
            return {
                show: false
            }
        },
        mounted: function() {
            this.show = !window.$cookies.isKey('d-p');
        },
        methods: {
            close() {
                window.$cookies.set('d-p', 1,"90D");
                this.show = false;
            },
        },

    }
</script>
<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .cookie-info {
        position: fixed;
        bottom: 0;
        background-color: $color-primary;
        color: $color-neutral-light;
        width: 100%;
    }
</style>